import useGoBack from '@/hooks/useGoBack';
import useTranslations from '@/i18n/useTranslations';
import { DropdownSort } from '@/shared-components/dropdown';
import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import Heading from '@/shared-components/text/components/Heading';

import './styles/HomeHeader.css';

export default function HomeHeader({
  onInput,
  value,
  icon,
  text,
  defaultOption,
  placeholder,
  type = "usual",
  onSort = () => {},
  showBackButton = true,
  hideSearch = false,
  hideSortControl = false,
}) {
  const tHome = useTranslations('common.shared.home');
  const goBackHandler = useGoBack();
  const hasIconOrBack = Boolean(icon) || showBackButton;
  return (
    <>
      <div className="home-header__container element-non-selectable">
        <div className="home-header__back-section">

          {showBackButton && (
            <button
              className="home-header__back-button"
              type="button"
              onClick={goBackHandler}
              aria-label={tHome('back_aria')}
            >
              <BackArrowIcon className="home-header__back-icon" />
            </button>
          )}

          {icon}

          <Heading
            className={[
              `home-header__back-text ${!hasIconOrBack ? "no-icon" : ""}`,
              "font-size-x-large"
            ].filter(Boolean).join(" ")}>
            {text}
          </Heading>
        </div>
        { !hideSearch && (["usual", ""].indexOf(type) !== -1 ?
          <div className="home-header__search-container">
            <SearchNavbarIcon className="home-header__search-icon"/>
            <input 
              type="text" 
              className="home-header__search-input" 
              value={value} 
              onInput={(e)=>onInput(e.target.value)} 
              placeholder={placeholder} 
              spellCheck={false} 
              autoComplete="off"
            />
          </div> :
          !hideSortControl && (
            <div className="home-header__popup-container"> {
              ["theme", "emotion", "color", "Theme", "Emotion", "Color"].indexOf(type) !== -1 ?
                <DropdownSort
                  defaultOption={defaultOption}
                  options={["Default", "Recent", "Relevant", "High to low", "Low to high"]}
                  onChangeOption={onSort}
                />
                :
                <DropdownSort
                  defaultOption={defaultOption}
                  options={["Relevant", "Recent", "High to low", "Low to high"]}
                  onChangeOption={onSort}
                /> }
            </div>
          ))}
      </div>
    </>
  );
}
